import * as React from 'react'
import { Typography } from '@material-ui/core'
import RouterMetaTags from '../../../components/molecules/RouterMetaTags'
import { Routes } from '../../../consts'
import PapersTable from '../../molecules/PapersTable'
import { usePaper } from '../../organisms/Paper'
import { TextLink } from './AdminIndexPage'

export const OutsideRequest = () => {
  const { papers } = usePaper()

  const outsideRequestPapers = React.useMemo(
    () => papers.filter(p => p.outsideRequest === true && p.outside !== true),
    [papers]
  )

  return (
    <>
      <TextLink route={Routes.Admin} arrow />
      <RouterMetaTags route={Routes.Admin_OutsideRequest} />
      <Typography variant="h2">{Routes.Admin_OutsideRequest.title}</Typography>
      <PapersTable papers={outsideRequestPapers} />
    </>
  )
}
